import { Allocation, AllocationStatus, EntityCalendarEvent, EntityViewCalendar } from '@jms/model';
import { defaultCalendarEventMapper } from '@workbuddy/services/entities/entity.calendar.default.mapper';
import { DateTime } from 'luxon';

export function isOverheadAllocation(record: Partial<Allocation>): boolean {
  return !!record.overhead || record.status === AllocationStatus.Overhead;
}

/** Occurrences retain the master id for domain commands and get a distinct calendar identity. */
export function mapAllocationCalendarEvent<T>(record: T, calendar: EntityViewCalendar<T>): EntityCalendarEvent | null {
  const event = defaultCalendarEventMapper(record, calendar);
  if (!event) return null;
  const allocation = record as unknown as Allocation;
  const allDay = allocation.allDay ?? event.allDay;
  const zone = calendar.timezone ?? 'UTC';
  // Scheduler ends include the last day; FullCalendar's all-day end is exclusive.
  const dates = allDay ? {
    start: DateTime.fromISO(event.start, { zone }).toISODate()!,
    ...(event.end ? { end: DateTime.fromISO(event.end, { zone }).plus({ days: 1 }).startOf('day').toISODate()! } : {}),
  } : {};
  return {
    ...event,
    ...dates,
    id: allocation.rule?._id ? `${allocation._id}@${event.start}` : event.id,
    allDay,
    ...(isOverheadAllocation(allocation) ? {
      title: allocation.overhead?.name || allocation.name || 'Overhead',
      color: allocation.overhead?.color,
    } : {}),
  };
}
